// extracted by mini-css-extract-plugin
export default {"wrapper":"logo_wrapper__obHus"};